var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiRrPhoneCall = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "fi-rr-phone-call_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2933",
    d: "M8.667.667A.667.667 0 0 1 9.333 0 6.674 6.674 0 0 1 16 6.667a.667.667 0 1 1-1.333 0 5.34 5.34 0 0 0-5.334-5.334.667.667 0 0 1-.666-.666M9.333 4A2.667 2.667 0 0 1 12 6.667a.667.667 0 0 0 1.333 0 4.004 4.004 0 0 0-4-4 .667.667 0 1 0 0 1.333m6.062 7.16a2.067 2.067 0 0 1 0 2.918l-.606.7C9.329 20.004-3.958 6.72 1.189 1.243l.766-.667A2.054 2.054 0 0 1 4.84.604c.02.02 1.256 1.625 1.256 1.625a2.067 2.067 0 0 1-.005 2.855l-.772.97a8.52 8.52 0 0 0 4.62 4.63l.978-.776a2.067 2.067 0 0 1 2.854-.004s1.604 1.235 1.624 1.255m-.917.969s-1.595-1.228-1.616-1.248a.733.733 0 0 0-1.033 0c-.018.018-1.362 1.09-1.362 1.09a.67.67 0 0 1-.653.101A10 10 0 0 1 3.934 6.2a.67.67 0 0 1 .096-.667S5.1 4.188 5.12 4.171a.733.733 0 0 0 0-1.033c-.021-.02-1.249-1.617-1.249-1.617a.733.733 0 0 0-1.006.026l-.767.667c-3.761 4.523 7.753 15.398 11.716 11.653l.607-.7a.747.747 0 0 0 .057-1.038"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "fi-rr-phone-call_svg__a"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgFiRrPhoneCall as ReactComponent };
export default __webpack_public_path__ + "955ae8f6c66251c61405b219091cb029.svg";